module.exports = __webpack_public_path__ + "img/product-placeholder-9.e5d8d36.png";